var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReaction4Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 24C40.25 15.025 32.975 7.75 24 7.75C15.025 7.75 7.75 15.025 7.75 24C7.75 32.975 15.025 40.25 24 40.25C32.975 40.25 40.25 32.975 40.25 24ZM4 24C4 12.9547 12.9547 4 24 4C35.0453 4 44 12.9547 44 24C44 35.0453 35.0453 44 24 44C12.9547 44 4 35.0453 4 24ZM30.1375 34.643C28.95 33.3617 26.9188 31.9945 24.0125 31.9945C21.1063 31.9945 19.075 33.3617 17.8875 34.643C17.1844 35.4008 15.9969 35.4555 15.2391 34.7523C14.4812 34.0492 14.4266 32.8617 15.1297 32.1039C16.8484 30.2445 19.8172 28.2445 24.0047 28.2445C28.1922 28.2445 31.1688 30.2367 32.8797 32.1039C33.5828 32.8617 33.5359 34.0492 32.7703 34.7523C32.0047 35.4555 30.825 35.4086 30.1219 34.643H30.1375ZM15.2812 20.25C15.2812 18.8695 16.4008 17.75 17.7812 17.75C19.1617 17.75 20.2812 18.8695 20.2812 20.25C20.2812 21.6305 19.1617 22.75 17.7812 22.75C16.4008 22.75 15.2812 21.6305 15.2812 20.25ZM30.2812 17.75C31.6617 17.75 32.7812 18.8695 32.7812 20.25C32.7812 21.6305 31.6617 22.75 30.2812 22.75C28.9008 22.75 27.7812 21.6305 27.7812 20.25C27.7812 18.8695 28.9008 17.75 30.2812 17.75Z",
    fill: "#FDC300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction4Active);
export default __webpack_public_path__ + "static/media/reaction-4-active.5bcaa9091537d3fec5c72e1e91220864.svg";
export { ForwardRef as ReactComponent };